import React from 'react'
import "./agenciespractise.css"
import practiseimg from '../../images/Vector.png'
const techprofesionalsList = [
    {
        id: 0,
        image: require('../../images/Ellipse 1227.png'),
        name: "Nanuka",
        surname: "Vadachkoria",
        position: "Product Manger"
    },
    {
        id: 1,
        image: require('../../images/gigi.png'),
        name: "Giorgi",
        surname: "Chichua",
        position: "UI/UX Designer"
    }
]
function agenciespractise() {

    return (
        <div className='agenciespractise'>
            <h1>Go beyond traditional practices </h1>
            <div className="agenciespractise-inner">
                <div className="pbox">
                    <h3>Better quality, bigger margins</h3>
                    <p>We recruit some of the region’s top talent at a fraction of your local rates. That means you can increase your projects’ margins without sacrificing quality. Additionally, It will provide you with the flexibility to scale up quickly when needed. Just in time, at a low cost.</p>
                    <img className='practiseimg' src={practiseimg} alt="" />
                </div>
                <div className="pbox">
                    <h3>Scale your team on demand</h3>
                    <p>Take on new projects without a single worry about staffing them. We have a significant capacity and an even bigger network of  tech professionals . But thats not all, you can reduce your costs and ensure your projects are completed on time.</p>
                    <div className="practicedeadline">
                        <div className="deadline start">
                            <span className='deadline-span'></span>
                            <div className="deadline-date">
                                <h4>Starting Deadline</h4>
                                <p>January 9, 2025.</p>
                            </div>
                        </div>
                        <div className="deadline end">
                            <span className='deadline-span'></span>
                            <div className="deadline-date">
                                <h4>Ending Deadline</h4>
                                <p>January 23, 2025</p>
                            </div>
                        </div>
                    </div>
                    <div className="techprofessionals-list">
                        <div className="techprofessionalslist-header">
                            <h2>Tech Proffesionals</h2>
                            <button>See all</button>
                        </div>
                        <div className="tech-professionals-list">
                            {
                                techprofesionalsList.map((tplist) => (
                                    <div className='techproflistcard' key={tplist.id}>
                                        <img src={tplist.image} alt="" />
                                        <div className="name-position">
                                            <span><h4>{tplist.name}</h4> &nbsp; <h4>{tplist.surname}</h4></span>
                                            <p className='position'>{tplist.position}</p>
                                        </div>

                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default agenciespractise